<template>
  <div
    class="flowchart-node"
    :style="nodeStyle"
    @mousedown="handleMousedown"
    @mouseover="handleMouseOver"
    @mouseleave="handleMouseLeave"
    v-bind:class="{ selected: options.selected === id }"
  >
    <div
      class="node-port node-input"
      @mousedown="inputMouseDown"
      @mouseup="inputMouseUp"
    ></div>
    <div class="node-main">
      <div v-text="type" class="node-type" :style="nodeTypeStyle"></div>
      <div v-if="!edit">
        <div :key="field.name" v-for="field in fields" class="label">
          <b v-if="showLabels">{{ field.name }}</b> {{ field.value }}
        </div>
      </div>
      <div v-if="edit">
        <div :key="field.name" v-for="(field, index) in fields">
          <label>{{ field.name }}</label>
          <input
            ref="input"
            v-if="field.type == 'String'"
            :id="id + '[' + field.name + ']'"
            v-model="fields[index].value"
            @input="syncLabel(field.name, $event)"
          />
        </div>
      </div>
    </div>
    <div class="node-port node-output" @mousedown="outputMouseDown"></div>
    <div v-show="show.delete" class="node-delete">&times;</div>
  </div>
</template>

<script>
export default {
  name: "FlowchartNode",
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, String],
      default: 1000,
    },
    color: {
      type: String,
      default: "#000000",
    },
    x: {
      type: Number,
      default: 0,
      validator(val) {
        return typeof val === "number";
      },
    },
    y: {
      type: Number,
      default: 0,
      validator(val) {
        return typeof val === "number";
      },
    },
    type: {
      type: String,
      default: "Default",
    },
    fields: {
      type: Array,
      default: [],
    },
    label: {
      type: String,
      default: "",
    },
    options: {
      type: Object,
      default() {
        return {
          centerX: 1024,
          scale: 1,
          centerY: 140,
        };
      },
    },
    showLabels: {
      type: Boolean,
    },
  },
  data() {
    return {
      show: {
        delete: false,
        edit: false,
      },
    };
  },
  computed: {
    nodeStyle() {
      return {
        top: this.options.centerY + this.y * this.options.scale + "px", // remove: this.options.offsetTop +
        left: this.options.centerX + this.x * this.options.scale + "px", // remove: this.options.offsetLeft +
        transform: `scale(${this.options.scale})`,
      };
    },
    nodeTypeStyle() {
      return {
        backgroundColor: this.color,
      };
    },
  },
  methods: {
    handleMousedown(e) {
      const target = e.target || e.srcElement;
      // console.log(target);
      if (
        target.className.indexOf("node-input") < 0 &&
        target.className.indexOf("node-output") < 0
      ) {
        this.$emit("nodeSelected", e);
      }
      //e.preventDefault();
    },
    handleMouseOver() {
      this.show.delete = true;
    },
    handleMouseLeave() {
      this.show.delete = false;
    },
    outputMouseDown(e) {
      this.$emit("linkingStart");
      e.preventDefault();
    },
    inputMouseDown(e) {
      e.preventDefault();
    },
    inputMouseUp(e) {
      this.$emit("linkingStop");
      e.preventDefault();
    },
    updateNode(e) {
      this.$emit("updateNode", e);
    },
    syncLabel(fieldName, event) {
      let id = this.$refs.input[0].id;
      let val = this.$refs.input[0].value;

      if (id == this.id + "[Label]") {
        this.$emit("updateNode", val);
      }
    },
  },
};
</script>

<style scoped>
.flowchart-node {
  margin: 0;
  min-width: 80px;
  min-height: 80px;
  position: absolute;
  box-sizing: border-box;
  border: none;
  background: white;
  z-index: 1;
  opacity: 0.9;
  cursor: move;
  transform-origin: top left;
}
.flowchart-node .node-main {
  text-align: center;
}
.flowchart-node .node-main .node-type {
  background: #f85;
  color: white;
  font-size: 13px;
  padding: 6px;
}
.flowchart-node .node-main .node-label {
  font-size: 13px;
}
.flowchart-node .node-port {
  position: absolute;
  width: 12px;
  height: 12px;
  left: 50%;
  transform: translate(-50%);
  border: 1px solid #ccc;
  border-radius: 100px;
  background: white;
}
.flowchart-node .node-port:hover {
  background: #f85;
  border: 1px solid #f85;
}
.flowchart-node .node-input {
  top: -8px;
}
.flowchart-node .node-output {
  bottom: -8px;
}
.flowchart-node .node-delete {
  position: absolute;
  right: -6px;
  top: -6px;
  font-size: 12px;
  width: 12px;
  height: 12px;
  color: #f85;
  cursor: pointer;
  background: white;
  border: 1px solid #f85;
  border-radius: 100px;
  text-align: center;
}
.flowchart-node .node-delete:hover {
  background: #f85;
  color: white;
}
.selected {
  /* box-shadow: 0 0 0 2px #f85; */
  box-shadow: 0 0 0 2px #000000;
}

.label {
  font-size: 13px;
}

.edit-box {
  height: 100%;
  /* border: none; */
  margin: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/FlowChart/FlowchartNode.vue